
import React from 'react';
import { Link } from 'react-router-dom';
export default function ServiceFeatures({ data = [], extraClass = "" }) {

  return (
    <section className={`service-features ${extraClass}`}>
      <div className="container">
        <div className="row service-row">
          {data.map((item, index) => (
            <div className="col-4 col-sm-4 col-md-4" key={index}>
              <Link to={item.link}>
              <div className="features-text">
                <img src="/assets/images/circle-vector.png" alt="Vector" className="img-responsive 
                circle-vector" loading="lazy" />
                <div className="number-text">
                  <div className="icons">
                    <img src={item.img} alt={item.title} className="img-responsive" loading="lazy" />
                  </div>
                  {/* <div className="number">{item.number}</div> */}
                </div>
                <div className="heading-wrap">
                  <div className="heading-sec">
                    <div className="heading" dangerouslySetInnerHTML={{ __html: item.title }} />
                  </div>
                  {/* <div className="img-sec">
                    <div className="icon-wraps">
                      <img src="/assets/images/feature-vector.webp" alt="feature"
                       className="img-responsive" loading="lazy" />
                    </div>
                  </div> */}
                </div>
              </div>
              </Link>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
